import { Breakpoints } from '@aiz-gl/omni-ui';

export const breakpoint = {
  lowResMonitor: <T>(value: T) => Breakpoints.lessThanHeight<T>(740, value),
};
